module.exports = __webpack_public_path__ + "static/media/maintenance-3.6e56bfe1.jpg";